export default function PillBadge({ children }: { children: React.ReactNode }) {
  return <span className="pill">{children}</span>;
}
